import React from 'react';
import { observer } from 'mobx-react';
import cx from 'classnames';
import { tP } from '../../translate';
import { LoginForm, PublicPagesWrapper } from './Components';
import '../../customStyle/form.less';
import Styles from './m_styles.less';
import './styles.less';

export const LoginPage: React.FC = observer(() => {
    return (
        <PublicPagesWrapper>
            <div className={cx(Styles.card)}>
                <div className={Styles.title}>{tP('Login')}</div>
                <div className={Styles.form}>
                    <LoginForm />
                </div>
            </div>
        </PublicPagesWrapper>
    );
});
